function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["__errors"];

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, Component } from 'react';
import { ADDITIONAL_PROPERTY_FLAG, deepEquals, descriptionId, getSchemaType, getTemplate, getUiOptions, ID_KEY, mergeObjects, TranslatableString, UI_OPTIONS_KEY } from '@rjsf/utils';
import isObject from 'lodash/isObject';
import omit from 'lodash/omit';
import Markdown from 'markdown-to-jsx';
/** The map of component type to FieldName */

var COMPONENT_TYPES = {
  array: 'ArrayField',
  boolean: 'BooleanField',
  integer: 'NumberField',
  number: 'NumberField',
  object: 'ObjectField',
  string: 'StringField',
  null: 'NullField'
};
/** Computes and returns which `Field` implementation to return in order to render the field represented by the
 * `schema`. The `uiOptions` are used to alter what potential `Field` implementation is actually returned. If no
 * appropriate `Field` implementation can be found then a wrapper around `UnsupportedFieldTemplate` is used.
 *
 * @param schema - The schema from which to obtain the type
 * @param uiOptions - The UI Options that may affect the component decision
 * @param idSchema - The id that is passed to the `UnsupportedFieldTemplate`
 * @param registry - The registry from which fields and templates are obtained
 * @returns - The `Field` component that is used to render the actual field data
 */

function getFieldComponent(schema, uiOptions, idSchema, registry) {
  var field = uiOptions.field;
  var fields = registry.fields,
      translateString = registry.translateString;

  if (typeof field === 'function') {
    return field;
  }

  if (typeof field === 'string' && field in fields) {
    return fields[field];
  }

  var schemaType = getSchemaType(schema);
  var type = Array.isArray(schemaType) ? schemaType[0] : schemaType || '';
  var schemaId = schema.$id;
  var componentName = COMPONENT_TYPES[type];

  if (schemaId && schemaId in fields) {
    componentName = schemaId;
  } // If the type is not defined and the schema uses 'anyOf' or 'oneOf', don't
  // render a field and let the MultiSchemaField component handle the form display


  if (!componentName && (schema.anyOf || schema.oneOf)) {
    return function () {
      return null;
    };
  }

  return componentName in fields ? fields[componentName] : function () {
    var UnsupportedFieldTemplate = getTemplate('UnsupportedFieldTemplate', registry, uiOptions);
    return _jsx(UnsupportedFieldTemplate, {
      schema: schema,
      idSchema: idSchema,
      reason: translateString(TranslatableString.UnknownFieldType, [String(schema.type)]),
      registry: registry
    });
  };
}
/** The `SchemaFieldRender` component is the work-horse of react-jsonschema-form, determining what kind of real field to
 * render based on the `schema`, `uiSchema` and all the other props. It also deals with rendering the `anyOf` and
 * `oneOf` fields.
 *
 * @param props - The `FieldProps` for this component
 */


function SchemaFieldRender(props) {
  var _a, _b, _c;

  var _schema = props.schema,
      _idSchema = props.idSchema,
      uiSchema = props.uiSchema,
      formData = props.formData,
      errorSchema = props.errorSchema,
      idPrefix = props.idPrefix,
      idSeparator = props.idSeparator,
      name = props.name,
      onChange = props.onChange,
      onKeyChange = props.onKeyChange,
      onDropPropertyClick = props.onDropPropertyClick,
      required = props.required,
      registry = props.registry,
      _props$wasPropertyKey = props.wasPropertyKeyModified,
      wasPropertyKeyModified = _props$wasPropertyKey === void 0 ? false : _props$wasPropertyKey;
  var formContext = registry.formContext,
      schemaUtils = registry.schemaUtils,
      globalUiOptions = registry.globalUiOptions;
  var uiOptions = getUiOptions(uiSchema, globalUiOptions);
  var FieldTemplate = getTemplate('FieldTemplate', registry, uiOptions);
  var DescriptionFieldTemplate = getTemplate('DescriptionFieldTemplate', registry, uiOptions);
  var FieldHelpTemplate = getTemplate('FieldHelpTemplate', registry, uiOptions);
  var FieldErrorTemplate = getTemplate('FieldErrorTemplate', registry, uiOptions);
  var schema = schemaUtils.retrieveSchema(_schema, formData);
  var fieldId = _idSchema[ID_KEY];
  var idSchema = mergeObjects(schemaUtils.toIdSchema(schema, fieldId, formData, idPrefix, idSeparator), _idSchema);
  /** Intermediary `onChange` handler for field components that will inject the `id` of the current field into the
   * `onChange` chain if it is not already being provided from a deeper level in the hierarchy
   */

  var handleFieldComponentChange = useCallback(function (formData, newErrorSchema, id) {
    var theId = id || fieldId;
    return onChange(formData, newErrorSchema, theId);
  }, [fieldId, onChange]);
  var FieldComponent = getFieldComponent(schema, uiOptions, idSchema, registry);
  var disabled = Boolean((_a = uiOptions.disabled) !== null && _a !== void 0 ? _a : props.disabled);
  var readonly = Boolean((_b = uiOptions.readonly) !== null && _b !== void 0 ? _b : props.readonly || props.schema.readOnly || schema.readOnly);
  var uiSchemaHideError = uiOptions.hideError; // Set hideError to the value provided in the uiSchema, otherwise stick with the prop to propagate to children

  var hideError = uiSchemaHideError === undefined ? props.hideError : Boolean(uiSchemaHideError);
  var autofocus = Boolean((_c = uiOptions.autofocus) !== null && _c !== void 0 ? _c : props.autofocus);

  if (Object.keys(schema).length === 0) {
    return null;
  }

  var displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);

  var _ref = errorSchema || {},
      __errors = _ref.__errors,
      fieldErrorSchema = _objectWithoutProperties(_ref, _excluded); // See #439: uiSchema: Don't pass consumed class names or style to child components


  var fieldUiSchema = omit(uiSchema, ['ui:classNames', 'classNames', 'ui:style']);

  if (UI_OPTIONS_KEY in fieldUiSchema) {
    fieldUiSchema[UI_OPTIONS_KEY] = omit(fieldUiSchema[UI_OPTIONS_KEY], ['classNames', 'style']);
  }

  var field = _jsx(FieldComponent, _objectSpread(_objectSpread({}, props), {}, {
    onChange: handleFieldComponentChange,
    idSchema: idSchema,
    schema: schema,
    uiSchema: fieldUiSchema,
    disabled: disabled,
    readonly: readonly,
    hideError: hideError,
    autofocus: autofocus,
    errorSchema: fieldErrorSchema,
    formContext: formContext,
    rawErrors: __errors
  }));

  var id = idSchema[ID_KEY]; // If this schema has a title defined, but the user has set a new key/label, retain their input.

  var label;

  if (wasPropertyKeyModified) {
    label = name;
  } else {
    label = ADDITIONAL_PROPERTY_FLAG in schema ? name : uiOptions.title || props.schema.title || schema.title || props.title || name;
  }

  var description = uiOptions.description || props.schema.description || schema.description || '';
  var richDescription = uiOptions.enableMarkdownInDescription ? _jsx(Markdown, {
    options: {
      disableParsingRawHTML: true
    },
    children: description
  }) : description;
  var help = uiOptions.help;
  var hidden = uiOptions.widget === 'hidden';
  var classNames = ['form-group', 'field', "field-".concat(getSchemaType(schema))];

  if (!hideError && __errors && __errors.length > 0) {
    classNames.push('field-error has-error has-danger');
  }

  if (uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema.classNames) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn("'uiSchema.classNames' is deprecated and may be removed in a major release; Use 'ui:classNames' instead.");
    }

    classNames.push(uiSchema.classNames);
  }

  if (uiOptions.classNames) {
    classNames.push(uiOptions.classNames);
  }

  var helpComponent = _jsx(FieldHelpTemplate, {
    help: help,
    idSchema: idSchema,
    schema: schema,
    uiSchema: uiSchema,
    hasErrors: !hideError && __errors && __errors.length > 0,
    registry: registry
  });
  /*
   * AnyOf/OneOf errors handled by child schema
   * unless it can be rendered as select control
   */


  var errorsComponent = hideError || (schema.anyOf || schema.oneOf) && !schemaUtils.isSelect(schema) ? undefined : _jsx(FieldErrorTemplate, {
    errors: __errors,
    errorSchema: errorSchema,
    idSchema: idSchema,
    schema: schema,
    uiSchema: uiSchema,
    registry: registry
  });
  var fieldProps = {
    description: _jsx(DescriptionFieldTemplate, {
      id: descriptionId(id),
      description: richDescription,
      schema: schema,
      uiSchema: uiSchema,
      registry: registry
    }),
    rawDescription: description,
    help: helpComponent,
    rawHelp: typeof help === 'string' ? help : undefined,
    errors: errorsComponent,
    rawErrors: hideError ? undefined : __errors,
    id: id,
    label: label,
    hidden: hidden,
    onChange: onChange,
    onKeyChange: onKeyChange,
    onDropPropertyClick: onDropPropertyClick,
    required: required,
    disabled: disabled,
    readonly: readonly,
    hideError: hideError,
    displayLabel: displayLabel,
    classNames: classNames.join(' ').trim(),
    style: uiOptions.style,
    formContext: formContext,
    formData: formData,
    schema: schema,
    uiSchema: uiSchema,
    registry: registry
  };
  var _AnyOfField = registry.fields.AnyOfField;
  var _OneOfField = registry.fields.OneOfField;
  var isReplacingAnyOrOneOf = (uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema['ui:field']) && (uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema['ui:fieldReplacesAnyOrOneOf']) === true;
  return _jsx(FieldTemplate, _objectSpread(_objectSpread({}, fieldProps), {}, {
    children: _jsxs(_Fragment, {
      children: [field, schema.anyOf && !isReplacingAnyOrOneOf && !schemaUtils.isSelect(schema) && _jsx(_AnyOfField, {
        name: name,
        disabled: disabled,
        readonly: readonly,
        hideError: hideError,
        errorSchema: errorSchema,
        formData: formData,
        formContext: formContext,
        idPrefix: idPrefix,
        idSchema: idSchema,
        idSeparator: idSeparator,
        onBlur: props.onBlur,
        onChange: props.onChange,
        onFocus: props.onFocus,
        options: schema.anyOf.map(function (_schema) {
          return schemaUtils.retrieveSchema(isObject(_schema) ? _schema : {}, formData);
        }),
        registry: registry,
        required: required,
        schema: schema,
        uiSchema: uiSchema
      }), schema.oneOf && !isReplacingAnyOrOneOf && !schemaUtils.isSelect(schema) && _jsx(_OneOfField, {
        name: name,
        disabled: disabled,
        readonly: readonly,
        hideError: hideError,
        errorSchema: errorSchema,
        formData: formData,
        formContext: formContext,
        idPrefix: idPrefix,
        idSchema: idSchema,
        idSeparator: idSeparator,
        onBlur: props.onBlur,
        onChange: props.onChange,
        onFocus: props.onFocus,
        options: schema.oneOf.map(function (_schema) {
          return schemaUtils.retrieveSchema(isObject(_schema) ? _schema : {}, formData);
        }),
        registry: registry,
        required: required,
        schema: schema,
        uiSchema: uiSchema
      })]
    })
  }));
}
/** The `SchemaField` component determines whether it is necessary to rerender the component based on any props changes
 * and if so, calls the `SchemaFieldRender` component with the props.
 */


var SchemaField = /*#__PURE__*/function (_Component) {
  _inherits(SchemaField, _Component);

  var _super = _createSuper(SchemaField);

  function SchemaField() {
    _classCallCheck(this, SchemaField);

    return _super.apply(this, arguments);
  }

  _createClass(SchemaField, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !deepEquals(this.props, nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      return _jsx(SchemaFieldRender, _objectSpread({}, this.props));
    }
  }]);

  return SchemaField;
}(Component);

export default SchemaField;